
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("aSQ2H", function(module, exports) {
/**
 * @generated SignedSource<<eba3ddf4122d34c052396e7e6f6d33bf>>
 * @relayHash 475721f730a3548a4f4eefeb978ba00d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7c04d39708c6a688256a9fd02644f4c9f3257ba8cf834d535b12f160ca61efb
const $20d3ce40728fbf7c$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useUserByLicensedProductsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useUserByLicensedProductsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "475721f730a3548a4f4eefeb978ba00d",
            "id": "d7c04d39708c6a688256a9fd02644f4c9f3257ba8cf834d535b12f160ca61efb",
            "metadata": {},
            "name": "useUserByLicensedProductsQuery",
            "operationKind": "query",
            "text": "query useUserByLicensedProductsQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$20d3ce40728fbf7c$var$node.hash = "d128f30f97ec5f59ea08d8e5ff26d122";
var $20d3ce40728fbf7c$export$2e2bcd8739ae039 = $20d3ce40728fbf7c$var$node;
module.exports["default"] = $20d3ce40728fbf7c$export$2e2bcd8739ae039;

});

parcelRegister("c8Y4F", function(module, exports) {
/**
 * @generated SignedSource<<37f3c934776838a31da0561c3367b039>>
 * @relayHash 54a5106deb8051638f67e17262ef90b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ae8f1aadd164d1b501e16f6020a287594e642feab79c3afc381daad3acbf576
const $a939e7843212ec9f$var$node = function() {
    var v0 = [
        {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "licenseConsumingUserCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "54a5106deb8051638f67e17262ef90b5",
            "id": "1ae8f1aadd164d1b501e16f6020a287594e642feab79c3afc381daad3acbf576",
            "metadata": {},
            "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery{license{licenseConsumingUserCount}}"
        }
    };
}();
$a939e7843212ec9f$var$node.hash = "eaf07b0d0888b09c16c5bc48d9bf826d";
var $a939e7843212ec9f$export$2e2bcd8739ae039 = $a939e7843212ec9f$var$node;
module.exports["default"] = $a939e7843212ec9f$export$2e2bcd8739ae039;

});

parcelRegister("g4evd", function(module, exports) {
/**
 * @generated SignedSource<<fbdeb79565959637d7e45870912ffd14>>
 * @relayHash 40ddeb0ef9f72faff15ea2ef539798b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81
const $8f22a426de8950e5$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "ScalarField",
                    "name": "feedTab"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedTypeSelectorRefreshQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedTypeSelectorRefreshQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "40ddeb0ef9f72faff15ea2ef539798b5",
            "id": "1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81",
            "metadata": {},
            "name": "useFeedTypeSelectorRefreshQuery",
            "operationKind": "query",
            "text": "query useFeedTypeSelectorRefreshQuery{userPreferences{__typename,feedTab}}"
        }
    };
}();
$8f22a426de8950e5$var$node.hash = "6ca55df8184dd78031693e2b650f878d";
var $8f22a426de8950e5$export$2e2bcd8739ae039 = $8f22a426de8950e5$var$node;
module.exports["default"] = $8f22a426de8950e5$export$2e2bcd8739ae039;

});

parcelRegister("3cztU", function(module, exports) {
/**
 * @generated SignedSource<<4f574d1bbf7b5f97d646547ee03c556a>>
 * @relayHash 027916460fcdde8e42909a043df68ff0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7d8d63b63a6f37feaf8f7e4d03bdb99ff0c74bf97fba9f1d1eb98bc12f44fcf1
const $a845950f81d03c88$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": "relevant",
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "recentActionsCount"
    }, v5 = {
        "kind": "ScalarField",
        "name": "datetime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "groupSize"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v11 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "KnownUser"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "UnknownUser"
    }, v13 = [
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v14 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "version"
    }, v16 = [
        v15 /*: any*/ ,
        v14 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        {
            "kind": "ScalarField",
            "name": "webui"
        }
    ], v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineText"
            }
        ],
        "type": "InlineComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            v21 /*: any*/ 
        ],
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v23 = {
        "kind": "ScalarField",
        "name": "source"
    }, v24 = {
        "kind": "ScalarField",
        "name": "title"
    }, v25 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v26 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v17 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v27 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v28 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v29 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v30 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v31 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v17 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v32 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v33 = {
        "concreteType": "FeedPageInformation",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v34 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": true,
        "selections": [
            v17 /*: any*/ 
        ]
    }, v35 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "ABSOLUTE"
                    }
                ],
                "kind": "ScalarField",
                "name": "path",
                "storageKey": "path(type:\"ABSOLUTE\")"
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "servingRecommendations"
    }, v37 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v38 = [
        v37 /*: any*/ ,
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v39 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v38 /*: any*/ 
    }, v40 = [
        v15 /*: any*/ ,
        v39 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v30 /*: any*/ 
                                            ]
                                        },
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v34 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                v35 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        v36 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v37 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v39 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v40 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v40 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v40 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v39 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v38 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v30 /*: any*/ 
                                            ]
                                        },
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v34 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v37 /*: any*/ ,
                                v8 /*: any*/ ,
                                v35 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        v36 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "027916460fcdde8e42909a043df68ff0",
            "id": "7d8d63b63a6f37feaf8f7e4d03bdb99ff0c74bf97fba9f1d1eb98bc12f44fcf1",
            "metadata": {},
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "operationKind": "query",
            "text": "query useFollowingFeedWithSortByStorageFeedContentQuery($first:Int,$after:String,$sortBy:String=\"relevant\"){feed(first:$first,after:$after,sortBy:$sortBy){nodes{recentActionsCount,summaryLineUpdate{__typename,datetime,type,groupSize,...on FeedEventCreate{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEdit{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEditLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventPublishLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventComment{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},comment{id,links{webui},location{__typename,type,...on InlineComment{inlineText}},body(representation:ATLAS_DOC_FORMAT){value}}}},source,content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),links{webui},history{createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}},createdDate},space{alias,id,key,name},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}}}},pageInfo{hasNextPage,endCursor}},getFeedUserConfig{spaces{id},users{__typename,displayName,profilePicture{path(type:ABSOLUTE)},...on KnownUser{accountId},...on UnknownUser{accountId}},servingRecommendations}}"
        }
    };
}();
$a845950f81d03c88$var$node.hash = "5d3db85b333af4987211e782a3dccf15";
var $a845950f81d03c88$export$2e2bcd8739ae039 = $a845950f81d03c88$var$node;
module.exports["default"] = $a845950f81d03c88$export$2e2bcd8739ae039;

});

parcelRegister("Yc1IN", function(module, exports) {
/**
 * @generated SignedSource<<bd6b1ec563cea711fab078f320bd9b02>>
 * @relayHash 5fa23ad64581bf268c729651d6bf4ddb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e98aed0963d75eecbe46cb82c413f1c7dab51ea1ec1170145ad8a9a88b6c3de0
const $ffca0a52a06c83ff$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": "relevant",
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "recentActionsCount"
    }, v5 = {
        "kind": "ScalarField",
        "name": "datetime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "groupSize"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v11 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "KnownUser"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "UnknownUser"
    }, v13 = [
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v14 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "version"
    }, v16 = [
        v15 /*: any*/ ,
        v14 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        {
            "kind": "ScalarField",
            "name": "webui"
        }
    ], v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineText"
            }
        ],
        "type": "InlineComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            v21 /*: any*/ 
        ],
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v23 = {
        "kind": "ScalarField",
        "name": "source"
    }, v24 = {
        "kind": "ScalarField",
        "name": "title"
    }, v25 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v26 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v17 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v27 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v28 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v29 = {
        "concreteType": "ConfluenceContentAISummaryResponse",
        "kind": "LinkedField",
        "name": "aiProperty",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "objectData"
            },
            {
                "kind": "ScalarField",
                "name": "createdAt"
            },
            {
                "kind": "ScalarField",
                "name": "errorMessage"
            }
        ]
    }, v30 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v31 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v32 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v17 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v33 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = {
        "concreteType": "FeedPageInformation",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v35 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": true,
        "selections": [
            v17 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "ABSOLUTE"
                    }
                ],
                "kind": "ScalarField",
                "name": "path",
                "storageKey": "path(type:\"ABSOLUTE\")"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "servingRecommendations"
    }, v38 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v39 = [
        v38 /*: any*/ ,
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v40 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v39 /*: any*/ 
    }, v41 = [
        v15 /*: any*/ ,
        v40 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FollowingFeedWithSortByStorageSnippetsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v34 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                v36 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        v37 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FollowingFeedWithSortByStorageSnippetsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v40 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v40 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v39 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v34 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v38 /*: any*/ ,
                                v8 /*: any*/ ,
                                v36 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        v37 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5fa23ad64581bf268c729651d6bf4ddb",
            "id": "e98aed0963d75eecbe46cb82c413f1c7dab51ea1ec1170145ad8a9a88b6c3de0",
            "metadata": {},
            "name": "FollowingFeedWithSortByStorageSnippetsQuery",
            "operationKind": "query",
            "text": "query FollowingFeedWithSortByStorageSnippetsQuery($first:Int,$after:String,$sortBy:String=\"relevant\"){feed(first:$first,after:$after,sortBy:$sortBy){nodes{recentActionsCount,summaryLineUpdate{__typename,datetime,type,groupSize,...on FeedEventCreate{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEdit{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEditLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventPublishLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventComment{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},comment{id,links{webui},location{__typename,type,...on InlineComment{inlineText}},body(representation:ATLAS_DOC_FORMAT){value}}}},source,content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),aiProperty{objectData,createdAt,errorMessage},links{webui},history{createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}},createdDate},space{alias,id,key,name},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}}}},pageInfo{hasNextPage,endCursor}},getFeedUserConfig{spaces{id},users{__typename,displayName,profilePicture{path(type:ABSOLUTE)},...on KnownUser{accountId},...on UnknownUser{accountId}},servingRecommendations}}"
        }
    };
}();
$ffca0a52a06c83ff$var$node.hash = "3d5373dca56a1cdfcca16a1aaa83ff13";
var $ffca0a52a06c83ff$export$2e2bcd8739ae039 = $ffca0a52a06c83ff$var$node;
module.exports["default"] = $ffca0a52a06c83ff$export$2e2bcd8739ae039;

});

parcelRegister("lNpDX", function(module, exports) {
/**
 * @generated SignedSource<<8ad738f7cd5bddfd309c63bbe975efaf>>
 * @relayHash 39acb1147d229935866fe5c76d20c1bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac244f8eb2900313dbd1f99458efd3a3edf69c82efb71c7fff3c8c7aa156021e
const $afadcf197f0b9a77$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": "default",
        "kind": "LocalArgument",
        "name": "timeGranularity"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "timeGranularity",
            "variableName": "timeGranularity"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v8 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v9 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v11 /*: any*/ 
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v17 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v18 = {
        "kind": "InlineFragment",
        "selections": v17 /*: any*/ ,
        "type": "KnownUser"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": v17 /*: any*/ ,
        "type": "UnknownUser"
    }, v20 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v22 = {
        "concreteType": "FeedPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "39acb1147d229935866fe5c76d20c1bc",
            "id": "ac244f8eb2900313dbd1f99458efd3a3edf69c82efb71c7fff3c8c7aa156021e",
            "metadata": {},
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "operationKind": "query",
            "text": "query usePopularFeedWithTimeGranularityStorageQuery($first:Int,$after:String,$timeGranularity:String=\"default\"){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$afadcf197f0b9a77$var$node.hash = "458c889823784393227130726e48009d";
var $afadcf197f0b9a77$export$2e2bcd8739ae039 = $afadcf197f0b9a77$var$node;
module.exports["default"] = $afadcf197f0b9a77$export$2e2bcd8739ae039;

});

parcelRegister("gFJ3I", function(module, exports) {
/**
 * @generated SignedSource<<52f22cfb18abb2462ec19d1b389ab30f>>
 * @relayHash 701c47ab92ba720656167a68651cabf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 945e7480c8024c5838976cd3c3e16f1bc80c56650f328afd46dd6931baf9bf0f
const $281954080cb05dad$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isRovoLLMEnabled"
    }, v3 = {
        "defaultValue": "default",
        "kind": "LocalArgument",
        "name": "timeGranularity"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "timeGranularity",
            "variableName": "timeGranularity"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v10 = {
        "condition": "isRovoLLMEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "entryPoint",
                        "value": "CONFLUENCE_HOME_POPULAR_FEED"
                    }
                ],
                "concreteType": "ConfluenceContentAISummaryResponse",
                "kind": "LinkedField",
                "name": "aiProperty",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "errorMessage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "createdAt"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "objectData"
                    }
                ],
                "storageKey": "aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\")"
            }
        ]
    }, v11 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v13 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v18 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v20 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "KnownUser"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "UnknownUser"
    }, v22 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v23 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v24 = {
        "concreteType": "FeedPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v24 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        v24 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "701c47ab92ba720656167a68651cabf8",
            "id": "945e7480c8024c5838976cd3c3e16f1bc80c56650f328afd46dd6931baf9bf0f",
            "metadata": {},
            "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
            "operationKind": "query",
            "text": "query PopularFeedWithTimeGranularityStorageSnippetsQuery($first:Int,$after:String,$timeGranularity:String=\"default\",$isRovoLLMEnabled:Boolean=false){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\")@include(if:$isRovoLLMEnabled){errorMessage,createdAt,objectData},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$281954080cb05dad$var$node.hash = "01929ccf73034c49133b68b9a80dd611";
var $281954080cb05dad$export$2e2bcd8739ae039 = $281954080cb05dad$var$node;
module.exports["default"] = $281954080cb05dad$export$2e2bcd8739ae039;

});

parcelRegister("d7td2", function(module, exports) {
/**
 * @generated SignedSource<<c91a75b1008ae7e27ac3d0fa999dfd5d>>
 * @relayHash 6e6daec1ee51db3b3653a64a4144cb12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cdbbbcf4cd5fbe5d40081d9bc1efc3b0378b8b6ef5afaf25636b2cd7158e02ee
const $25444c17515b1490$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isRovoLLMEnabled"
    }, v3 = {
        "defaultValue": "default",
        "kind": "LocalArgument",
        "name": "timeGranularity"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "timeGranularity",
            "variableName": "timeGranularity"
        }
    ], v5 = {
        "condition": "isRovoLLMEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "entryPoint",
                        "value": "CONFLUENCE_HOME_POPULAR_FEED"
                    },
                    {
                        "kind": "Literal",
                        "name": "objectType",
                        "value": "snippet_v2"
                    }
                ],
                "concreteType": "ConfluenceContentAISummaryResponse",
                "kind": "LinkedField",
                "name": "aiProperty",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "errorMessage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "createdAt"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "objectData"
                    }
                ],
                "storageKey": "aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\",objectType:\"snippet_v2\")"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v10 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v11 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v13 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v18 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v20 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "KnownUser"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "UnknownUser"
    }, v22 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v23 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v24 = {
        "concreteType": "FeedPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PopularFeedWithTimeGranularityStorageSnippetsV2Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v24 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PopularFeedWithTimeGranularityStorageSnippetsV2Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        v24 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "6e6daec1ee51db3b3653a64a4144cb12",
            "id": "cdbbbcf4cd5fbe5d40081d9bc1efc3b0378b8b6ef5afaf25636b2cd7158e02ee",
            "metadata": {},
            "name": "PopularFeedWithTimeGranularityStorageSnippetsV2Query",
            "operationKind": "query",
            "text": "query PopularFeedWithTimeGranularityStorageSnippetsV2Query($first:Int,$after:String,$timeGranularity:String=\"default\",$isRovoLLMEnabled:Boolean=false){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\",objectType:snippet_v2)@include(if:$isRovoLLMEnabled){errorMessage,createdAt,objectData},content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$25444c17515b1490$var$node.hash = "aff44ffc8d4a5147fced8a7e10d8221b";
var $25444c17515b1490$export$2e2bcd8739ae039 = $25444c17515b1490$var$node;
module.exports["default"] = $25444c17515b1490$export$2e2bcd8739ae039;

});

parcelRegister("lkQRq", function(module, exports) {
/**
 * @generated SignedSource<<1786786af5fbe9ee3a2042731a1d34f9>>
 * @relayHash f1f5bc833b3adcfaa8f23a0262a11c35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3dfcdba660c43ea3c005773a8867b277288a1f1828accb84953d86fd5503884
const $8e3067533735c561$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HomeWidget",
                    "kind": "LinkedField",
                    "name": "homeWidgets",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "state"
                        },
                        v0 /*: any*/ 
                    ]
                },
                v0 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useHomeWidgetStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useHomeWidgetStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f1f5bc833b3adcfaa8f23a0262a11c35",
            "id": "a3dfcdba660c43ea3c005773a8867b277288a1f1828accb84953d86fd5503884",
            "metadata": {},
            "name": "useHomeWidgetStateQuery",
            "operationKind": "query",
            "text": "query useHomeWidgetStateQuery{userPreferences{homeWidgets{id,state,__typename},__typename}}"
        }
    };
}();
$8e3067533735c561$var$node.hash = "2b3d6cba775f89e74fb24fec1d37c65d";
var $8e3067533735c561$export$2e2bcd8739ae039 = $8e3067533735c561$var$node;
module.exports["default"] = $8e3067533735c561$export$2e2bcd8739ae039;

});

parcelRegister("cMfVN", function(module, exports) {
/**
 * @generated SignedSource<<c10a3479344de239969bd1a93235453c>>
 * @relayHash 485b07e69670e84889e1c718d8693e52
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 212c349f0cf0225cfd610d7a4583eaceeb584b90c8bb730b8316e6bde9ba4e2c
const $760c61ad763022c8$var$node = function() {
    var v0 = [
        {
            "concreteType": "SpaViewModel",
            "kind": "LinkedField",
            "name": "spaViewContext",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "welcomeMessageEditUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "welcomeMessageHtml"
                },
                {
                    "kind": "ScalarField",
                    "name": "isWelcomeMessageCustomized"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceKeys"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceContexts"
                },
                {
                    "kind": "ScalarField",
                    "name": "showWelcomeMessageEditHint"
                },
                {
                    "kind": "ScalarField",
                    "name": "showEditButton"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "WelcomeMessagesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "WelcomeMessagesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "485b07e69670e84889e1c718d8693e52",
            "id": "212c349f0cf0225cfd610d7a4583eaceeb584b90c8bb730b8316e6bde9ba4e2c",
            "metadata": {},
            "name": "WelcomeMessagesQuery",
            "operationKind": "query",
            "text": "query WelcomeMessagesQuery{spaViewContext{welcomeMessageEditUrl,welcomeMessageHtml,isWelcomeMessageCustomized,resourceKeys,resourceContexts,showWelcomeMessageEditHint,showEditButton}}"
        }
    };
}();
$760c61ad763022c8$var$node.hash = "7a7432847603f3b8c92c592f7e345430";
var $760c61ad763022c8$export$2e2bcd8739ae039 = $760c61ad763022c8$var$node;
module.exports["default"] = $760c61ad763022c8$export$2e2bcd8739ae039;

});

parcelRegister("bDjCi", function(module, exports) {
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE", () => (parcelRequire("e8WZK")).ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE);
$parcel$export(module.exports, "CALENDAR_CONTEXT", () => (parcelRequire("ltKTq")).CALENDAR_CONTEXT);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $e8WZK = parcelRequire("e8WZK");


var $ltKTq = parcelRequire("ltKTq");


const $0fe83f4fb6168025$export$666c7163d0ae1b3f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "UHi5n",
    name: "LazyTeamCalendars",
    loader: async ()=>(await (parcelRequire("4sYEP"))).TeamCalendar
});

const $0fe83f4fb6168025$export$9bc5a864d70a9980 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DHsKy",
    name: "LazyHomepageCard",
    loader: async ()=>(await (parcelRequire("hnTz1"))).HomepageCard
});

const $0fe83f4fb6168025$export$85a8d72151ca049b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sxt9o",
    name: "LazyTeamCalendarSiteSettingsPage",
    loader: async ()=>(await (parcelRequire("eTrnh"))).TeamCalendarSiteSettingsPage
});
module.exports["LazyTeamCalendars"] = $0fe83f4fb6168025$export$666c7163d0ae1b3f;
module.exports["LazyHomepageCard"] = $0fe83f4fb6168025$export$9bc5a864d70a9980;
module.exports["LazyTeamCalendarSiteSettingsPage"] = $0fe83f4fb6168025$export$85a8d72151ca049b;

});

parcelRegister("4sYEP", function(module, exports) {

let $3408d447637ed805$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $3408d447637ed805$var$load("4oONP"),
    $3408d447637ed805$var$load("9lUu8"),
    $3408d447637ed805$var$load("59K3I"),
    $3408d447637ed805$var$load("ibYtB"),
    $3408d447637ed805$var$load("6wr18"),
    $3408d447637ed805$var$load("9OQNK"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("46TWH"), 5)),
    $3408d447637ed805$var$load("5oU5X"),
    $3408d447637ed805$var$load("fNWwG"),
    $3408d447637ed805$var$load("j2bbk"),
    $3408d447637ed805$var$load("j104l"),
    $3408d447637ed805$var$load("5t3NJ"),
    $3408d447637ed805$var$load("4Jbf1"),
    $3408d447637ed805$var$load("6uYZX"),
    $3408d447637ed805$var$load("eEyVs"),
    $3408d447637ed805$var$load("1tzsM"),
    $3408d447637ed805$var$load("llxGi"),
    $3408d447637ed805$var$load("9a2oY"),
    $3408d447637ed805$var$load("2RWyc"),
    $3408d447637ed805$var$load("hLjS5"),
    $3408d447637ed805$var$load("9pso5"),
    $3408d447637ed805$var$load("4fYzp"),
    $3408d447637ed805$var$load("90USU"),
    $3408d447637ed805$var$load("c831e"),
    $3408d447637ed805$var$load("Wowvf"),
    $3408d447637ed805$var$load("cHQ50"),
    $3408d447637ed805$var$load("ffEVr"),
    $3408d447637ed805$var$load("37ldp"),
    $3408d447637ed805$var$load("eiF7i"),
    $3408d447637ed805$var$load("alL67")
]).then(()=>parcelRequire('biV8C'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("alui6", function(module, exports) {
"use strict";

var $h4lNe = parcelRequire("h4lNe");

module.exports = $h4lNe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("h4lNe", function(module, exports) {
"use strict";
let $c6d3b70899d3a8aa$var$cachedBundles = {};
let $c6d3b70899d3a8aa$var$cachedPreloads = {};
let $c6d3b70899d3a8aa$var$cachedPrefetches = {};
function $c6d3b70899d3a8aa$var$getCache(type) {
    switch(type){
        case 'preload':
            return $c6d3b70899d3a8aa$var$cachedPreloads;
        case 'prefetch':
            return $c6d3b70899d3a8aa$var$cachedPrefetches;
        default:
            return $c6d3b70899d3a8aa$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $c6d3b70899d3a8aa$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("hnTz1", function(module, exports) {

let $ca7faf7b2e46c3a0$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $ca7faf7b2e46c3a0$var$load("4oONP"),
    $ca7faf7b2e46c3a0$var$load("59K3I"),
    $ca7faf7b2e46c3a0$var$load("ibYtB"),
    $ca7faf7b2e46c3a0$var$load("6wr18"),
    $ca7faf7b2e46c3a0$var$load("9OQNK"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("46TWH"), 5)),
    $ca7faf7b2e46c3a0$var$load("5oU5X"),
    $ca7faf7b2e46c3a0$var$load("fNWwG"),
    $ca7faf7b2e46c3a0$var$load("j2bbk"),
    $ca7faf7b2e46c3a0$var$load("j104l"),
    $ca7faf7b2e46c3a0$var$load("5t3NJ"),
    $ca7faf7b2e46c3a0$var$load("4Jbf1"),
    $ca7faf7b2e46c3a0$var$load("6uYZX"),
    $ca7faf7b2e46c3a0$var$load("eEyVs"),
    $ca7faf7b2e46c3a0$var$load("1tzsM"),
    $ca7faf7b2e46c3a0$var$load("llxGi"),
    $ca7faf7b2e46c3a0$var$load("9a2oY"),
    $ca7faf7b2e46c3a0$var$load("2RWyc"),
    $ca7faf7b2e46c3a0$var$load("hLjS5"),
    $ca7faf7b2e46c3a0$var$load("9pso5"),
    $ca7faf7b2e46c3a0$var$load("4fYzp"),
    $ca7faf7b2e46c3a0$var$load("c831e"),
    $ca7faf7b2e46c3a0$var$load("Wowvf"),
    $ca7faf7b2e46c3a0$var$load("cHQ50"),
    $ca7faf7b2e46c3a0$var$load("ffEVr"),
    $ca7faf7b2e46c3a0$var$load("37ldp"),
    $ca7faf7b2e46c3a0$var$load("eiF7i"),
    $ca7faf7b2e46c3a0$var$load("3orE4")
]).then(()=>parcelRequire('IdTEh'));

});

parcelRegister("eTrnh", function(module, exports) {

let $ad7b6fc50b889c45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ad7b6fc50b889c45$var$load("5oU5X"),
    $ad7b6fc50b889c45$var$load("hhss7"),
    $ad7b6fc50b889c45$var$load("9g1FS")
]).then(()=>parcelRequire('4GncZ'));

});

parcelRegister("e8WZK", function(module, exports) {
const $5e4945ce4960200f$export$c0e43f82fc27fe04 = 'adminTeamCalendars';
module.exports["ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE"] = $5e4945ce4960200f$export$c0e43f82fc27fe04;

});

parcelRegister("y9T5W", function(module, exports) {
const $c2f13451050bd3c6$export$a1180afea81894e6 = 6;
module.exports["ALL_RECENT_ITEMS_COUNT_HOME_REFRESH"] = $c2f13451050bd3c6$export$a1180afea81894e6;

});

parcelRegister("2Ujef", function(module, exports) {
/**
 * @generated SignedSource<<5a11bc75dfd8762ef129fa2338a54406>>
 * @relayHash 29c4cb130b82621c8ae64d700e35e867
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0f8088baf02eccbefe567796b693e824d4a461ef0707b0e60aa6a11c98152551
const $451651b37d1d3ba3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "objectTypes"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "objectTypes",
                            "variableName": "objectTypes"
                        },
                        {
                            "kind": "Literal",
                            "name": "products",
                            "value": [
                                "CONFLUENCE"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "arguments"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "rootContainerIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "rootContainerIds"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "AND"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "title"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v10 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v11 = [
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "editUi"
        }
    ], v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiDraft",
                "plural": false,
                "selections": v12 /*: any*/ 
            },
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiPublished",
                "plural": false,
                "selections": v12 /*: any*/ 
            }
        ]
    }, v14 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "alias": "pageStatus",
                "kind": "ScalarField",
                "name": "status"
            },
            v9 /*: any*/ ,
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v11 /*: any*/ 
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "alias": "blogStatus",
                "kind": "ScalarField",
                "name": "status"
            },
            v9 /*: any*/ ,
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v11 /*: any*/ 
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceBlogPost"
    }, v17 = {
        "kind": "ScalarField",
        "name": "status"
    }, v18 = [
        v10 /*: any*/ 
    ], v19 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v14 /*: any*/ 
        ],
        "type": "ConfluenceWhiteboard"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v14 /*: any*/ 
        ],
        "type": "ConfluenceDatabase"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceSlideLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v14 /*: any*/ 
        ],
        "type": "ConfluenceSlide"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceEmbedLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceEmbed"
    }, v23 = {
        "concreteType": "ActivityEvent",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "ScalarField",
                "name": "eventType"
            }
        ]
    }, v24 = [
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentWorkQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentWorkQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v24 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v24 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v24 /*: any*/ ,
                                                                            "type": "MercuryPortfolio"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "29c4cb130b82621c8ae64d700e35e867",
            "id": "0f8088baf02eccbefe567796b693e824d4a461ef0707b0e60aa6a11c98152551",
            "metadata": {},
            "name": "HomeRecentWorkQuery",
            "operationKind": "query",
            "text": "query HomeRecentWorkQuery($cloudId:ID!,$first:Int,$after:String,$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceSlide{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}},event{id,timestamp,eventType}}}}}}}"
        }
    };
}();
$451651b37d1d3ba3$var$node.hash = "a45e25c98c3a3864ddaee2dc7df8090c";
var $451651b37d1d3ba3$export$2e2bcd8739ae039 = $451651b37d1d3ba3$var$node;
module.exports["default"] = $451651b37d1d3ba3$export$2e2bcd8739ae039;

});

parcelRegister("a67vB", function(module, exports) {

var $d4Pk4 = parcelRequire("d4Pk4");


var $ctLrB = parcelRequire("ctLrB");


var $2Ujef = parcelRequire("2Ujef");

const $fed37ec4c6d5a8b4$export$93fc89076fcc0c52 = (0, $2Ujef.default);


const $4b2ee2ac7b774614$export$154132902c275093 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, isSlidesEnabled: isSlidesEnabled = false, first: first = 10 })=>({
        query: (0, $fed37ec4c6d5a8b4$export$93fc89076fcc0c52),
        variables: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            first: first,
            after: '',
            objectTypes: [
                (0, $ctLrB.ActivitiesObjectType).PAGE,
                (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
                (0, $ctLrB.ActivitiesObjectType).EMBED,
                (0, $ctLrB.ActivitiesObjectType).CONTENT,
                ...isWhiteboardViewedEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                ] : [],
                ...isDatabaseEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).DATABASE
                ] : [],
                ...isSlidesEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).SLIDE
                ] : []
            ]
        },
        skip: !isLoggedIn
    });
module.exports["getRecentWorkQueryOptions"] = $4b2ee2ac7b774614$export$154132902c275093;

});


$parcel$global.rlb("fkbDX")
//# sourceMappingURL=ForYou.0fc91ad4.js.map
